import PeriodCloseSvg from 'assets/icons/navigation/period_close.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(PeriodCloseSvg, {
  displayName: 'PeriodCloseIcon',
});
